import { ICraving, ICravingSosConts, ICravingSosContsDetail } from 'src/@types/apiResponse';

import { TApiResponseData } from '../apiTypes';
import instance from '../axios';

/** 갈망 기록 */
export const setUserCraving = async (userCraving: ICraving) => {
  try {
    const url = `/userCraving`;

    const response = await instance.post<TApiResponseData<any>>(url, userCraving);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 갈망SOS 컨텐츠 조회 */
export const getCravingSosConts = async () => {
  try {
    const url = `/cravingSosConts`;

    const response = await instance.get<TApiResponseData<ICravingSosConts[]>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 갈망SOS 컨텐츠 상세조회 */
export const getCravingSosContsDetail = async (cravingSosContsSid: number) => {
  try {
    const url = `/cravingSosConts/${cravingSosContsSid}`;

    const response = await instance.get<TApiResponseData<ICravingSosContsDetail[]>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 갈망SOS 컨텐츠 기록 */
export const setUserCravingSosConts = async (cravingSosContsSid: number) => {
  try {
    const url = `/userCravingSosConts`;
    const payload = {
      cravingSosContsSid: cravingSosContsSid,
    };

    const response = await instance.post<TApiResponseData<any>>(url, payload);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
